module.exports = __webpack_public_path__ + "media/images/footer/instagram-a7e8c943f1cf32fa3ea56d0d5b608858.svg";